import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const TABS = [
  { key: '/', label: '홈', icon: '🏠', match: (p) => p === '/' },
  { key: '/experts', label: '전문가', icon: '👨‍🔬', match: (p) => p.startsWith('/experts') },
  { key: '/snap', label: '촬영', icon: '📷', isFab: true, match: (p) => p.startsWith('/snap') },
  { key: '/records', label: '기록', icon: '📋', match: (p) => p.startsWith('/records') },
  { key: '/scenario-builder', label: '빌더', icon: '🛠️', match: (p) => p.startsWith('/scenario-builder') },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Hide on WrongAnswerNote page (/register)
  if (location.pathname === '/register') return null;

  const handleTabClick = (tab) => {
    // 비로그인 상태에서 홈 외 탭 클릭 시 홈으로 이동 (로그인 유도)
    if (!user && tab.key !== '/') {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (tab.key === '/snap') {
      navigate('/');
    } else {
      navigate(tab.key);
    }
  };

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: 'var(--nav-height, 64px)',
      zIndex: 'var(--z-nav, 1000)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      background: 'rgba(22, 33, 62, 0.85)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      {TABS.map((tab) => {
        const isActive = tab.match(location.pathname);
        const isDisabled = !user && tab.key !== '/';

        if (tab.isFab) {
          return (
            <button
              key={tab.key}
              onClick={() => handleTabClick(tab)}
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '50%',
                border: 'none',
                background: isDisabled
                  ? 'linear-gradient(135deg, #888 0%, #666 100%)'
                  : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                fontSize: '1.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: isDisabled
                  ? '0 4px 16px rgba(100, 100, 100, 0.3)'
                  : '0 4px 16px rgba(102, 126, 234, 0.4)',
                transform: isActive ? 'scale(1.1)' : 'scale(1)',
                transition: 'transform var(--transition-spring, 300ms cubic-bezier(0.34, 1.56, 0.64, 1))',
                marginTop: '-20px',
                opacity: isDisabled ? 0.7 : 1,
              }}
            >
              {tab.icon}
            </button>
          );
        }

        return (
          <button
            key={tab.key}
            onClick={() => handleTabClick(tab)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px',
              background: 'none',
              border: 'none',
              color: isDisabled
                ? 'rgba(255, 255, 255, 0.3)'
                : isActive
                  ? 'white'
                  : 'rgba(255, 255, 255, 0.5)',
              cursor: 'pointer',
              padding: '0.5rem 1rem',
              transition: 'color var(--transition-fast, 150ms)',
              minWidth: '64px',
            }}
          >
            <span style={{ fontSize: '1.25rem' }}>{tab.icon}</span>
            <span style={{
              fontSize: '0.65rem',
              fontWeight: isActive ? 700 : 400,
              letterSpacing: '0.02em',
            }}>
              {tab.label}
            </span>
            {isActive && !isDisabled && (
              <div style={{
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                background: 'var(--color-accent, #667eea)',
                marginTop: '1px',
              }} />
            )}
          </button>
        );
      })}
    </nav>
  );
}
